import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PageList from '#/modules/commonComponents/PageList';
import { can } from '#/modules/infra/auth/can';
import srmMgmtNavigate from '#/modules/infra/navigation/srmMgmtNavigate';

const SrmMgmtHubPage = () => {
  const permissions = useSelector((state) => state.infra.permissions);
  const linkList = useMemo(
    () => srmMgmtNavigate.filter(
      (item) => !item.permission || can(permissions, item.permission),
    ),
    [permissions],
  );

  return <PageList title="供應商管理" linkList={linkList} />;
};

export default SrmMgmtHubPage;
